{
  "name": "heysegment-cli",
  "version": "0.1.11",
  "type": "module",
  "license": "MIT",
  "description": "CLI for validating, building, and packaging heysegment projects",
  "bin": {
    "heysegment": "./dist/cli.js"
  },
  "files": [
    "dist"
  ],
  "sideEffects": false,
  "engines": {
    "node": ">=22"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "heysegment": "bun src/cli.ts",
    "build": "tsup",
    "check": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest",
    "clean": "rm -rf dist",
    "prepack": "pnpm run build"
  },
  "dependencies": {
    "@effect/platform-node": "4.0.0-beta.78",
    "effect": "4.0.0-beta.78"
  },
  "devDependencies": {
    "@repo/contracts": "workspace:^",
    "@repo/services": "workspace:^",
    "@repo/site-validations": "workspace:^",
    "@repo/templates": "workspace:^",
    "@types/node": "^25.3.3",
    "tsup": "^8.3.5",
    "typescript": "^5.7.0",
    "vitest": "^3.2.4"
  },
  "optionalDependencies": {
    "sharp": "^0.35.3"
  }
}
